exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.vehicle[data-v-2fa2aa71] {\r\n  margin-bottom: 24px;\n}\n.image[data-v-2fa2aa71] {\r\n  width: 100%;\n}\n.title[data-v-2fa2aa71] {\r\n  font-size: 22px;\r\n  font-weight: bold;\r\n  padding-bottom: 5px;\n}\n.subtitle[data-v-2fa2aa71] {\r\n  font-size: 16px;\r\n  text-transform: uppercase;\r\n  margin: 0 0 15px 0;\n}\nul.actions > li[data-v-2fa2aa71] {\r\n  border-bottom: 1px solid rgba(33, 33, 33, 0.2);\r\n  padding: 15px 0;\n}\nul.actions > li > a[data-v-2fa2aa71] {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  text-transform: uppercase;\r\n  color: #212121;\n}\nul.actions > li > a > span.dbc-icon[data-v-2fa2aa71] {\r\n  color: #2c61d5;\r\n  font-size: 1.6em;\r\n  padding: 0;\r\n  margin-right: 10px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2fa2aa71","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/components/garage/garage-vehicles-list.vue
// module id = 571
// module chunks = 0